<script setup lang="ts">
const t2 = useT2({})

const props = defineProps<{
  product: ProductListingFragmentFull | None
  media: gen.ImageTaggedFragment[]
  mainReplace: gen.ImageNodeItemFragment | None
}>()

const init3 = useInited('init3')
const data = shallowReactive({
  activeImage: undefined as gen.ImageTaggedFragment | None,
  render: false,
  showImagesModal: false,
})

const imagesBase = computed((): gen.ImageTaggedFragment[][] => {
  const [first, ...items] = props.media
  if (!first) return []
  const rest: [gen.ImageTaggedFragment[], gen.ImageTaggedFragment[], gen.ImageTaggedFragment[]] = [[first], [], []]
  items.forEach((item, index) => rest[index % 2 === 0 ? 1 : 2].push(item))
  return rest
})

const images = computed((): gen.ImageTaggedFragment[][] => {
  const list = imagesBase.value
  const replace = props.mainReplace
  if (replace) return helpers.toSpliced(list, 0, 1, [{ img: { image2: replace } }])
  return list
})

const empty = computed((): boolean => !images.value.at(0)?.at(0))

function open(item: None | gen.ImageTaggedFragment) {
  data.activeImage = item
  data.showImagesModal = true
  if (!data.render) data.render = true
}

// usePreloadLcpImage(() => {
//   const img = images.value.at(0)?.at(0)?.img?.image2
//   // should be 50vw
//   return { url: img?.img || img?.url, widths: [420, 640, 960], sizes: '(max-width: 768px) 100vw, 640px' }
// })
</script>

<template>
  <div :class="[$style.cont, empty && $style.empty]">
    <BaseImage v-if="empty" sizes="fixed:50" class="_h100 _w100" />

    <div v-for="(items, index) in images" :key="index" :class="[index === 0 ? $style.first : $style.side, $clsClass('p-collage')]">
      <div v-for="(item, index2) in items" :key="index2" class="_relative">
        <BaseImage :img="item.img" :sizes="index === 0 ? '50vw' : '25vw'" :ratio="item.ratio" :lazy="index !== 0" :alt="index === 0 ? product?.title : undefined" autoplay>
          <LazyProductImageTags v-if="init3" :tags="item.tags" />
        </BaseImage>

        <ClientOnly>
          <button v-if="init3" :class="[$style.btn, 'ButtonIcon']" type="button" @click="open(item)">
            <LazyButtonIcon :class="$style.btn2" :txt="t2('Zoom')" to="span"><LazyIconExpand2 class="_svg16" /></LazyButtonIcon>
          </button>
        </ClientOnly>
      </div>
    </div>

    <LazyProductImageCollage2Modal v-if="init3 && images.length && product" v-model:open="data.showImagesModal" :product :render="data.render" :images :active-image="data.activeImage" />
  </div>
</template>

<style module>
.cont {
  composes: global(_gap06);
  composes: global(_align-start);
  min-height: 60vh;
  display: grid;
  grid-template: min-content max-content / 1fr 1fr;
}
.empty {
  composes: global(_ctr);

  composes: global(_mt04);
  composes: global(_mb04);
  composes: global(_ml04);
  composes: global(_mr04);
  composes: global(_br9);

  background: var(--black-6);
}
.side {
  composes: global(_col);
  gap: inherit;
}
.first {
  grid-column: span 2;
}

.btn {
  composes: global(_row);
  composes: global(_absolute);
  composes: global(_inset);

  composes: global(_pt1);
  composes: global(_pr1);
  composes: global(_pb1);
  composes: global(_pl1);
  composes: global(_end);
  composes: global(_endA);

  border: 0;
  background: transparent;
}
.btn2 {
  opacity: 0.1;
  transition:
    opacity 300ms cubic-bezier(0.23, 1, 0.32, 1),
    background-color 300ms cubic-bezier(0.23, 1, 0.32, 1),
    transform 300ms cubic-bezier(0.23, 1, 0.32, 1);
}
.btn2:hover {
  transform: scale(0.96);
  transform-origin: center center;
}
.btn:hover .btn2 {
  opacity: 0.99;
  background-color: #fafafa;
}
</style>
